// noinspection NonAsciiCharacters

import { Category } from '../type';
import preval from 'preval.macro';

export const categories: Record<string, Category> = preval`
  const fs = require('fs');
  const json = fs.readFileSync(__dirname + '/../../data/category.json', 'utf8');
  const object = JSON.parse(json);
  const convertInternal = (rawCategories) => {
    return Object.fromEntries(rawCategories['카테고리'].map((v) => ([v['분류명'], {
      name: v['분류명'],
      emoji: v['이모지'],
    }])));
  };
  module.exports = convertInternal(object);
`;
